module.exports = __webpack_public_path__ + "static/media/back.c2f6e63e.jpg";